import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDetail, fetchCheckList, fetchUpdate } from '@/api/PMS/houseDeliveryManage/decorationRegistration';
import { fetchList as fetchChargeStardList } from '@/api/PMS/chargeManagement/chargingParameterSetting/chargingStandardSetting/chargingStandardSetting';
export default {
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      propstree: {
        label: 'name',
        value: 'id',
        children: 'pmsTree'
      },
      rules: {
        decorateEndDate: [{
          required: true,
          message: '请选择装修结束时间',
          trigger: 'change'
        }]
      },
      loading: false,
      chargeOption: [],
      customerList: [],
      cascaderItem: [],
      houseList: [],
      list: [],
      chargeStandardList: [],
      childData: {}
    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  },
  created: function created() {
    this.init();
    this.loadChargeOption();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.chargeStandardList = [];
      this.customerList = [];
      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchCheckList(queryData).then(function (response) {
          if (response.data.data) {
            _this.list = response.data.data;

            _this.list.forEach(function (item) {
              item.refundAmount = '0';
            });
          }
        });
        fetchDetail(queryData).then(function (response) {
          if (response.data.code === 200) {
            _this.childData = response.data.data;

            _this.$set(_this.childData, 'decorateEndDate', '');

            _this.$set(_this.childData, 'chargeStandardId', '');
          }
        });
      } else {
        this.childData = {};
      }
    },
    handleEndDate: function handleEndDate(val) {
      if (val) {
        var startTime = new Date(this.childData.beginDate).getTime();
        var endTime = new Date(val).getTime();

        if (endTime < startTime) {
          this.$message.error('装修结束时间不能早于装修开始时间');
          this.$set(this.childData, 'decorateEndDate', '');
          return;
        }
      }

      this.list.forEach(function (item) {
        item.endDate = val;
      });
    },
    handleChargeSelect: function handleChargeSelect(chargeList) {
      var _this2 = this;

      if (chargeList && chargeList.length > 0) {
        this.$set(this.childData, 'refundAmount', 0);
        chargeList.forEach(function (item1) {
          _this2.list.forEach(function (item2, index) {
            if (item1 === index) {
              _this2.childData.refundAmount += parseInt(item2.refundAmount);

              _this2.$set(_this2.list, 'refundAmount', item2.amount);
            }
          });
        });
      } else {
        this.$set(this.childData, 'refundAmount', 0);
        this.list.forEach(function (item) {
          _this2.$set(_this2.list, 'refundAmount', '0');
        });
      }
    },
    loadChargeOption: function loadChargeOption() {
      var _this3 = this;

      fetchChargeStardList({}).then(function (r) {
        _this3.chargeOption = r.data.data;
      });
    },
    handUpdate: function handUpdate() {
      var _this4 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this4.keyValue > 0) {
            var decorateBillListVos = [];

            _this4.list.forEach(function (item1, index) {
              _this4.chargeStandardList.forEach(function (item2) {
                item1.isPrestore = _this4.childData.checked ? 1 : 0;
                if (index === item2) decorateBillListVos.push(item1);
              });
            });

            var updateObj = {
              isFlag: 1,
              decorateId: _this4.childData.decorateId,
              areaId: _this4.childData.areaId,
              houseId: _this4.childData.houseId,
              customerId: _this4.childData.customerId,
              decorateRemark: _this4.childData.decorateRemark,
              beginDate: _this4.childData.beginDate,
              decorateEndDate: _this4.childData.decorateEndDate,
              decorateBillListVos: decorateBillListVos
            };
            fetchUpdate(updateObj).then(function () {
              _this4.$emit('handCancle', true);

              _this4.Alert({
                alertType: 'update',
                message: '验收成功'
              });
            });
          }
        } else {
          _this4.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle');
    }
  }
};